<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m">
					{{ $t('rtr_personal-how-janopay_creditcard.title1') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-how-janopay_creditcard.text1') }}<br />{{
						$t('rtr_personal-how-janopay_creditcard.text2')
					}}<br />{{ $t('rtr_personal-how-janopay_creditcard.text3') }}
				</p>
			</div>
		</div>
		<section>
			<div class="img_area_01 d_flex justify_center">
				<div>
					<h2 class="headline_m">
						{{ $t('rtr_personal-how-janopay_creditcard.title2') }}
					</h2>
					<div class="creditcard_bg text">
						<p>
							<span class="icon type_01"></span>
							{{ $t('rtr_personal-how-janopay_creditcard.text14') }}
						</p>
						<p>
							<span class="icon type_02"></span>
							{{ $t('rtr_personal-how-janopay_creditcard.text12') }}&nbsp;{{
								$t('rtr_personal-how-janopay_creditcard.text13')
							}}
						</p>
						<p>
							<span class="icon type_03"></span>
							{{ $t('rtr_personal-how-janopay_creditcard.text15') }}&nbsp;{{
								$t('rtr_personal-how-janopay_creditcard.text16')
							}}
						</p>
					</div>
				</div>
			</div>
		</section>

		<section class="content_area bg_gray">
			<div class="sub_content tal">
				<div class="mb_30">
					<p class="title_s">
						{{ $t('rtr_personal-how-janopay_creditcard.title3') }}
					</p>
					<p class="body_m mb_10">
						{{ $t('rtr_personal-how-janopay_creditcard.text4') }}<br />
						{{ $t('rtr_personal-how-janopay_creditcard.text5') }}
					</p>
					<router-link to class="m_link_type_02 justify_start" @click="notYet">
						{{ $t('rtr_personal-how-janopay_creditcard.text26') }}
						<span class="CIRCLE_ARROW"></span>
					</router-link>
				</div>
				<div>
					<p class="title_s">
						{{ $t('rtr_personal-how-janopay_creditcard.text6') }}<br />
						{{ $t('rtr_personal-how-janopay_creditcard.text7') }}<br />
					</p>
					<p class="body_m mb_10">
						{{ $t('rtr_personal-how-janopay_creditcard.text8') }}<br />
						{{ $t('rtr_personal-how-janopay_creditcard.text9') }}<br />
						{{ $t('rtr_personal-how-janopay_creditcard.text10') }}
					</p>
					<router-link
						:to="{ name: 'terms' }"
						class="m_link_type_02 justify_start"
					>
						{{ $t('rtr_personal-how-janopay_creditcard.text27') }}
						<span class="CIRCLE_ARROW"></span>
					</router-link>
				</div>
			</div>
		</section>

		<section>
			<div class="content_area">
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							<span class="fc_red">{{
								$t('rtr_personal-how-janopay_creditcard.title4')
							}}</span
							><br />
							{{ $t('rtr_personal-how-janopay_creditcard.title5') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/janopay_creditcard_03.png" alt="" />
						</div>
						<div class="text">
							<p class="body_m">
								{{ $t('rtr_personal-how-janopay_creditcard.text17') }}
								{{ $t('rtr_personal-how-janopay_creditcard.text18') }}
								{{ $t('rtr_personal-how-janopay_creditcard.text19') }}<br />
								{{ $t('rtr_personal-how-janopay_creditcard.text20') }}
								{{ $t('rtr_personal-how-janopay_creditcard.text21') }}
							</p>
						</div>
					</div>
				</div>
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-how-janopay_creditcard.title6') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/janopay_creditcard_04.png" alt="" />
						</div>
						<div>
							<p class="body_m">
								{{ $t('rtr_personal-how-janopay_creditcard.text22') }}<br />{{
									$t('rtr_personal-how-janopay_creditcard.text23')
								}}
								{{ $t('rtr_personal-how-janopay_creditcard.text24') }}
							</p>
						</div>
						<router-link to class="m_link_type_02" @click="notYet">
							{{ $t('rtr_personal-how-janopay_creditcard.text25') }}
							<span class="CIRCLE_ARROW"></span>
						</router-link>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
export default {
	name: 'JanopayCreditcard.m',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
<style scoped></style>
